import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faPen, faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import styles from 'components/UI/V3/Timeline/Item/Action/TimelineItemAction.module.scss';
import React from 'react';

interface TimelineItemActionProps {
    icon: IconProp;
    onClick?: () => void;
    className?: string;
}

export const TimelineItemAction: React.FC<TimelineItemActionProps> = ({ icon, onClick, className }) => {
    return (
        <button
            className={clsx(styles.root, className)}
            onClick={onClick}
        >
            {icon && <FontAwesomeIcon icon={icon} />}
        </button>
    );
};
